import classNames from "classnames";
import styles from "./ListItem.module.css";

interface Props {
  items: (string | undefined)[];
  wideLayout: boolean;
}

const ListHeader = ({ items, wideLayout }: Props) => (
  <tr
    className={classNames(
      styles.row,
      wideLayout ? styles["row-grid-wide"] : styles["row-grid-medium"],
    )}
  >
    {items.map((item, index) =>
      item ? (
        <th key={index} scope="col" className={styles.label}>
          <strong>{item}</strong>
        </th>
      ) : (
        <th key={index}></th>
      ),
    )}
  </tr>
);

export default ListHeader;
